import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Section, Button } from '../components/ui';
import './Message.css';

const Message = () => {
    const navigate = useNavigate();

    return (
        <Section id="approach" variant="default" className="message-section anchor-target">
            <div className="message-container">
                <motion.div
                    className="message-content"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-100px' }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="message-heading">How the pieces fit together</h2>
                    <p className="message-description">
                        Staying ahead matters for organisations of every size. MotionSpace combines what we see in the
                        field every day:
                    </p>
                    <p className="message-description">
                        <strong>Change management consulting</strong> to align people and process;{' '}
                        <strong>angel investing and private equity</strong> when capital and governance should move
                        together; and <strong>automation, AI, and analytics</strong>—solutions we deliver and analytics
                        tools we build so insight and speed are not an afterthought. We help you blend or sequence
                        mandates as your context evolves.
                    </p>
                    <div className="message-buttons">
                        <Button variant="secondary" size="lg" onClick={() => navigate('/contact')}>
                            Connect
                        </Button>
                        <Button variant="outline" size="lg" onClick={() => navigate('/services')}>
                            Explore services
                        </Button>
                    </div>
                </motion.div>
            </div>
        </Section>
    );
};

export default Message;
